class CSQCOutils {
    racineLocalStorage = 'csqc_coursEte'

    /**
    * Concatène une string avec le marqueur de séparation demandée
    * */
    ConcateneTexte(texteOrigine, texteAjoute, separateur = ', ') {
      let retour = texteOrigine;
      if (CSQCOutils.TexteVide(texteOrigine) === false) {
        retour += separateur;
      }

      return retour + texteAjoute;
    }

    /**
    * Retourne true si le texte n'est pas défini ou s'il est null ou vide. Les espaces ne sont pas retirer
    * @param {any} texte
    */
    TexteVide(texte, retirerEspace = true) {
      let retour = (texte === undefined || texte == null || texte === '');
      if (retour === false && retirerEspace === true) {
        const temp = texte;
        retour = temp.replace(' ', '') === '';
      }

      return retour;
    }

    /**
    * Pad un texte avec des caractères à gauche
    * @param {string} texte Texte à padder
    * @param {string} caractere Caractère à utiliser
    * @param {number} longueurFinale Longueur finale à atteindre
    */
    PadGauche(texte, caractere, longueurFinale) {
      while (texte.length < longueurFinale) {
        texte = caractere + texte;
      }
      return texte;
    }

    /**
    * Pad un texte avec des caractères à droite
    * @param {string} texte Texte à padder
    * @param {string} caractere Caractère à utiliser
    * @param {number} longueurFinale Longueur finale à atteindre
    */
    PadDroit(texte, caractere, longueurFinale) {
      while (texte.length < longueurFinale) {
        texte += caractere;
      }
      return texte;
    }

    /**
    * Transforme un nombre en string en arrondissant au nombre maximal de décimales. Ex : 14,57582 avec un affichage sur 2 décimales sera 15,58
    * Si le nombre est 14,6 avec 2 décimales, le retour sera 14,6
    * @param {number} nombre Nombre à transformer en string
    * @param {number} nbDecimale Nombre maximal de décimales à afficher
    * @returns {string}
    */
    DecimaleVariable(nombre, nbDecimale) {
      let valeurRetour = 0;
      while (valeurRetour === 0 && nbDecimale > 0) {
        const multiplicateur = 10 ** (nbDecimale - 1);
        valeurRetour = (nombre * multiplicateur) % 1;
        if (valeurRetour === 0) {
          nbDecimale -= 1;
        }
      }
      let retour = nombre.toFixed(nbDecimale);
      // Retirer les derniers 0 ayant pu s'inscruster dû aux arrondissements.
      while (retour.length > 1 && retour.lastIndexOf('0') === retour.length - 1) {
        retour = retour.substring(0, retour.length - 1);
      }
      if (retour.lastIndexOf('.') === retour.length - 1) {
        retour = retour.substring(0, retour.length - 1); // Retirer le point s'il termine le nombre
      }
      return retour.replace('.', ',');
    }

    /**
    * Transforme un nombre en string en y mettant le nombre de décimale à afficher.
    * @param {number} nombre Nombre à transformer en string
    * @param {number} nbDecimale Nombre de décimales à afficher
    * @returns {string}
    */
    DecimaleNonVariable(nombre, nbDecimale) {
      return this.DecimaleVersString(nombre, nbDecimale, false).replace('.', ',');
    }

    /**
    * Transforme un boolean en string avec la première lettre minuscule.
    * @param {boolean} bool Bool à mettre en string
    */
    BoolVersString(bool) {
      if (bool === true) {
        return 'true';
      }
      return 'false';
    }

    /**
    * Transforme une string en nombre.
    * @param {string} texte string à mettre en number. Peut-être un entier ou une décimale avec virgule ou point
    */
    StringVersNombre(texte) {
      texte = texte.replace(',', '.'); // On remplace les virgules par des points.
      return Number(texte);
    }

    /**
    * Transforme une string en number avec des options pour le nombre de décimales.
    * @param {number} nombre Nombre à transformer
    * @param {number} nbDecimale Nombre de décimales à afficher au maximum
    * @param {boolean} afficherDecimaleVariable Si true, alors on affiche que les décimales nécessaires, jusqu'à nbDecimale. Ex : 4,2 et 4,25 Si False, nous auront 4,20 et 4,25
    * @param {string} separateur Séparateur à utiliser pour la décimale. La virgule ou le point. La virgule est utilisée par défaut.
    */
    DecimaleVersString(nombre, nbDecimale, afficherDecimaleVariable, separateur = ',') {
      let retour = '';
      if (afficherDecimaleVariable === true) retour = this.decimaleVariable(nombre, nbDecimale);
      else retour = nombre.toFixed(nbDecimale);
      retour.replace('.', separateur);
      return retour;
    }

    /**
    * Transforme une décimale en formateur heure:minute. Ex : 2,5 => 2:30
    * @param {number} heures Nombre à mettre en string de type heure.
    * @param {number} separateur Séparateur heure, minute. Le : est utilisé par défaut.
    */
    DecimaleVersHeure(heures, separateur = ':') {
      if (Math.round((heures % 1) * 60) < 10) return `${Math.floor(heures) + separateur}0${Math.round((heures % 1) * 60)}`;
      return Math.floor(heures) + separateur + Math.round((heures % 1) * 60);
    }

    /**
    * Transforme différent type de fin de ligne comme des \n en <br />
    * @param {string} texte Texte à modifier et retourner
    */
    FinLigneVersBR(texte) {
      return texte.replace(/(?:\r\n|\r|\n)/g, '<br />');
    }

    /**
    * Transforme une date en string.
    * Le principe est de séparer la string selon le séparateur et de créer une nouvelle date avec les 3 nombres que ça donne.
    * @param {string} dateStr Date en string
    */
    StringVersDate(dateStr, separateur = '-') {
      const parties = dateStr.split(separateur);
      if (parties.length < 3) {
        throw new Error(`Conversion de date invalide. Format incorrect, attendu (yyyy-mm-dd), reçu : ${dateStr}`);
      }
      const retourDateTemp = new Date(this.StringVersNombre(parties[0]), this.StringVersNombre(parties[1]) - 1, this.StringVersNombre(parties[2]), 0, 0, 0, 0); // Les mois débutent le compte à 0.
      return retourDateTemp;
    }

    /**
    * Transforme une date en string sous la forme YYYY-mm-dd
    * @param {Date} d Date à mettre en string
    */
    DateVersString(d) {
      let month = `${d.getMonth() + 1}`;
      let day = `${d.getDate()}`;
      const year = d.getFullYear();
      if (month.length < 2) month = `0${month}`;
      if (day.length < 2) day = `0${day}`;
      return [year, month, day].join('-');
    }

    /**
    * Retourne la valeur numérique d'un nombre sous forme de string. Si le texte n'est pas un nombre NAN sera retourné.
    * @param {string} texte Texte à transformer en nombre
    */
    ValeurNumeriqueDepuisTexte(texte) {
      return parseFloat(texte);
    }

    /**
    * Fabriquer une nouvelle instance de l'objet à retournet et y assigne tous les attributs publiques de la source.
    * Si un attribut n'existe pas dans la définition de la classe du type de retour, il sera quand même créé dynamiquement et aucune erreur ne sera soulevée
    * Si le constructeur
    * @param {object} donneeBrut Objet de donnée brut source
    */
    FabriquerUnObjetAnonyme(objetAnonyme) {
      const objetRetour = {};
      // eslint-disable-next-line no-restricted-syntax
      for (const key in objetAnonyme) {
        if (Array.isArray(objetAnonyme[key])) {
          objetRetour[key] = [];
          for (let i = 0; i < objetAnonyme[key].length; i += 1) {
            objetRetour[key].push(this.FabriquerUnObjetAnonyme(objetAnonyme[key][i]));
          }
        } else {
          objetRetour[key] = objetAnonyme[key];
        }
      }
      return objetRetour;
    }

    /**
    * Bind les attributs d'un objet vers un autre. Les attributs de la source qui n'existe pas dans la destination seront créés automatiquement
    * @param {object} source Objet de donnée brut source
    * @param {object} destination Objet de donnée brut source
    */
    BinderDonnee(source, destination) {
      if (destination == null) destination = {};

      // eslint-disable-next-line no-restricted-syntax, guard-for-in
      for (const key in source) {
        destination[key] = source[key];
      }
      // return destination;
    }

    SetThemeDark(valeur) {
      localStorage.setItem(`${this.racineLocalStorage}ThemeDark`, valeur);
    }

    SetLanguage(valeur) {
      localStorage.setItem(`${this.racineLocalStorage}Langue`, valeur);
    }

    GetThemeDark() {
      const valeur = localStorage.getItem(`${this.racineLocalStorage}ThemeDark`);

      if (typeof valeur === 'string') {
        if (valeur === 'true') return true;

        return false;
      }

      return valeur;
    }

    GetLangue() {
      const valeur = localStorage.getItem(`${this.racineLocalStorage}Langue`);
      if (typeof valeur === 'string') {
        return valeur;
      }

      return 'fr';
    }

    GetUrlBaseAPI() {
      let baseUrl = window.location.origin;
      // eslint-disable-next-line no-use-before-define
      if (csqcoutils.TexteVide(window.Location.pathname) === false) {
        baseUrl += window.Location.pathname;
      }
      baseUrl += '/api/';

      return baseUrl;
    }

    Cloner(object) {
      return JSON.parse(JSON.stringify(object));
    }

    ExtraireExtension(fichier) {
      // eslint-disable-next-line no-use-before-define
      if (csqcoutils.TexteVide(fichier.name) === true) return '';

      const parties = fichier.name.split('.');
      if (parties.length === 0) return '';

      return parties[parties.length - 1];
    }

    TailleMax() {
      return 95 * 1048576;
    }
}

const csqcoutils = new CSQCOutils();

export default csqcoutils;
